import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GenreModel } from '../interfaces/movie.model';

@Injectable({
  providedIn: 'root',
})
export class GenresService {
  baseUrl = `${environment.apiEndpoint}/Genre`;

  constructor(private http: HttpClient) {}

  getAllGenres(): Observable<GenreModel[]> {
    return this.http.get<GenreModel[]>(this.baseUrl);
  }

  getGenreById(id: string) {
    return this.http
      .get<GenreModel[]>(this.baseUrl)
      .pipe(map((genres) => genres.filter((genre) => genre.id === Number(id))));
  }
  getGenreByName(name: string) {
    return this.http
      .get<GenreModel[]>(this.baseUrl)
      .pipe(map((genres) => genres.filter((genre) => genre.name === String(name))));
  }
}
